import { useTranslation } from "react-i18next";
import PageBreadcrumb from "../../../../shared/ui/common/PageBreadCrumb";
import PageMeta from "../../../../shared/ui/common/PageMeta";
import PatientAddForm from "../components/AddForm/PatientAddForm";
import { useTherapist } from "../../../../context/TherapistProvider";

export default function AddPatient() {
  const { t } = useTranslation();
  const { therapist } = useTherapist();

  return (
    <div>
      <PageMeta />
      <PageBreadcrumb pageTitle={t("patient.addNewPatientPageTitle")} />
      <div className="flex justify-center w-full pt-8 pb-12">
        <div className="w-full max-w-xl">
          <PatientAddForm therapistID={therapist?.id ?? ""} />
        </div>
      </div>
    </div>
  );
}
